// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1ZAHP","actions":"GroupTable_actions__2vbAF","deleteModalFooter":"GroupTable_deleteModalFooter__2rG6M"};